<div class="flex gap-x-4 w-full">
  <ng-content></ng-content>
</div>
